import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { LanguageManagementService } from '../../../service/language-management.service';
import { KeyValueSet, LeftRightWrapper, LocalService } from '../../../service/local.service';

@Component({
  selector: 'app-left-right-selection',
  templateUrl: './left-right-selection.component.html',
  styleUrls: ['./left-right-selection.component.scss']
})
export class LeftRightSelectionComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["left_right_selection"]; @Input() wrapper: LeftRightWrapper; @Output() onSelectionUpdated = new EventEmitter();
  destination: KeyValueSet[] = []; maxBodyHeight = 0;
  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.onLoad();
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetMaxModalBodyHeight(10);
    this.cdr.detectChanges();
  }

  onLoad() {
    this.wrapper.source.forEach(x => {
      this.destination.push({ key: x.key, value: x.value } as KeyValueSet);
    });
  }

  onClick(index) {
    let checkedItems: string[] = [];
    switch (index) {
      case 1: {
        checkedItems = this.wrapper.source.filter(x => x.isSelected).map(x => x.key);
      } break;
      case 2: {
        checkedItems = this.wrapper.source.filter(x => !(this.wrapper.selected.indexOf(x.key) > -1)).map(x => x.key);
      } break;
      case 3: {
        checkedItems = this.destination.filter(x => x.isSelected).map(x => x.key);
      } break;
      case 4: {
        checkedItems = this.wrapper.selected;
      } break;
    }
    if (checkedItems.length > 0) {
      switch (index) {
        case 1:
        case 2: {
          this.wrapper.selected.push(...checkedItems);
        } break;
        case 3:
        case 4: {
          this.wrapper.selected = this.wrapper.selected.filter(x => !(checkedItems.indexOf(x) > -1));
        } break;
      }
      checkedItems.forEach(x => {
        let itemSource = this.wrapper.source.find(y => y.key == x);
        if (itemSource)
          itemSource.isSelected = false;
        let itemDestination = this.destination.find(y => y.key == x);
        if (itemDestination)
          itemDestination.isSelected = false;
      });
      this.wrapper.selected = Array.from(new Set(this.wrapper.selected));
      this.onSelectionUpdated.emit(this.wrapper.selected);
    }
  }
}
